import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { GET_ALL_COUNTRY_DATA } from "../../../store/Global/actiontype";
import { createSelfNewAccount, registerEmailVerified, registerOtpVerified } from "../../../store/auth/register/actions";
import { REGISTER_USER_INITIAL } from "../../../store/auth/register/actionTypes";

export const useRegistration = () => {
    const dispatch = useDispatch();
    const { country_master_isd_icd } = useSelector((state) => state?.globalReducer);
    const [password, setPassword] = useState("");
    const emailRules = /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@(?!(?:[-]))[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

    useEffect(() => {
        dispatch({ type: REGISTER_USER_INITIAL });
        dispatch({ type: GET_ALL_COUNTRY_DATA });
    }, [dispatch]);

    const emailValidationSchema = yup.object({
        email: yup
            .string()
            .required("Email is required")
            .max(100, 'Email must be 100 characters or less')
            .matches(/^\S+$/, 'Email must not contain spaces')
            .matches(/^[\x00-\x7F]+$/, 'Email must be ASCII only')
            .matches(/^[^<>]*$/, 'Invalid characters detected')
            .matches(emailRules, 'Please enter a valid email address'),
    });

    const otpValidationSchema = yup.object({
        otp: yup.array()
            .of(yup.string().matches(/^[0-9]$/, "Only numbers allowed"))
            .required("OTP is required")
            .test("complete-otp", "Enter complete OTP", (otp) =>
                otp.every((val) => val !== "")
            ),
    })

    const sendEmailInitialValues = {
        email: "",
    }

    const createAccountInitialValues = {
        companyName: "",
        firstName: "",
        lastName: "",
        password: "",
        phoneNumber: "",
        industryType: "AGENT",
        opCode: country_master_isd_icd[1]?.value,
        acceptTerms: "",
    }

    const createAccountValidationSchema = yup.object({
        companyName: yup
            .string()
            .required("Company name is required")
            .max(254, "Company name must be 254 characters or less")
            .matches(/^[\x00-\x7F]+$/, 'Company name must contain only ASCII characters')
            .matches(/^[^<>]*$/, 'Company name contains invalid characters'),

        firstName: yup
            .string()
            .required("First name is required")
            .max(254, "First name must be 254 characters or less")
            .matches(/^[\x00-\x7F]+$/, 'First name must contain only ASCII characters')
            .matches(/^[^<>]*$/, 'First name contains invalid characters'),

        lastName: yup
            .string()
            .notRequired()
            .max(254, "First name must be 254 characters or less")
            .when([], {
                is: (val) => !!val, // Only apply matches if there's a value
                then: (schema) =>
                    schema
                        .matches(/^[\x00-\x7F]+$/, 'Last name must contain only ASCII characters')
                        .matches(/^[^<>]*$/, 'Last name contains invalid characters'),
            }),
        password: yup.string().required("Password is required"),
        opCode: yup.string().required("Country Code is required"),
        phoneNumber: yup
            .string()
            .required("Phone number is required")
            .matches(/^\d{10}$/, "Please enter valid phone number"),
        acceptTerms: yup
            .boolean()
            .oneOf([true], 'You must accept the terms and conditions')
            .required('You must accept the terms and conditions'),
    })

    const generatePassword = () => {
        const lowerCase = "abcdefghijklmnopqrstuvwxyz";
        const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const numbers = "0123456789";
        const symbols = "!@#$%^&*()_+{}[]<>?";

        let characters = lowerCase + upperCase;
        characters += numbers;
        characters += symbols;

        let newPassword = "";
        for (let i = 0; i < 12; i++) {
            newPassword += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return newPassword;
    };

    const resetRegistration = () => {
        dispatch({ type: REGISTER_USER_INITIAL });
    }

    return {
        emailValidationSchema,
        sendEmailInitialValues,
        country_master_isd_icd,
        otpValidationSchema,
        generatePassword,
        createAccountInitialValues,
        createAccountValidationSchema,
        resetRegistration
    }

}


export default useRegistration;
